import {Component, HostBinding, Input, OnInit, ViewChild, inject} from '@angular/core';
import {ClsCatalogosExpIns} from '../../../../core/models/cls-catalogo-general';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxExcelExporterService, IgxPdfExporterService } from '@infragistics/igniteui-angular/grids/core';
import {ClsConfig} from '../../../../util/cls-config';
import {EnumMasOpciones} from '../../../../core/models/enum/enum-mas-opciones';
import {ClsUtil} from '../../../../util/cls-util';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {AppPresupuestosService} from '../../../../core/services/app-presupuestos.service';
import {EnumCatalogoGralBanderas} from '../../../../core/models/enum/enum-catalogo-gral-banderas';
import {FiltroGeneralComponent} from '../filtro-general/filtro-general.component';
import {VtnGenericaComponent} from '../../ventanas/vtn-generica/vtn-generica.component';
import {TranslateModule} from '@ngx-translate/core';
import {MasOpcionesGridComponent} from '../mas-opciones-grid/mas-opciones-grid.component';
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../../core/pipes/summary-pipe-neo.pipe";
import {GenericoService} from "../../../../core/services/generico.service";
import {AppInfoService} from "../../../../core/services/app-info.service";
import { CrearComponenteDinamicoService } from '../../../../core/services/crear-componente-dinamico.service';

@Component({
  selector: 'app-catalogo-general',
  templateUrl: './catalogo-general.component.html',
  styleUrls: ['./catalogo-general.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    IgxIconComponent,
    FiltroGeneralComponent,
    MasOpcionesGridComponent,
    TranslateModule,
    SummaryPipeNeoPipe
  ]
})
export class CatalogoGeneralComponent extends ClsConfig implements OnInit {
  private servicioGen = inject(GenericoService);
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridExpInsumos', {static: true})
  public gridExpInsumos: IgxGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;
  @Input()
  public filtrarTipo: number[] = [];
  @Input()
  public filtrarPorBandera: EnumCatalogoGralBanderas = EnumCatalogoGralBanderas.Ninguno;
  @Input()
  public todasLasColumnas = false;

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public dataExpInsumo: ClsCatalogosExpIns[];
  public vtnGenerico: VtnGenericaComponent;
  // OBJ
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public cargarDatos() {
    this.dataExpInsumo = [];
    if (this.filtrarTipo.length === 0) {
      switch (this.filtrarPorBandera) {
        // case EnumCatalogoGralBanderas.Ninguno:
        //   this.dataExpInsumo = this.infPpto.pptoActivoCompletoJSON.CatExpIns;
        //   break;
        case EnumCatalogoGralBanderas.EsCH:
          this.dataExpInsumo = this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.EsCostoHorario);
          break;
        case EnumCatalogoGralBanderas.EsPorcentaje:
          this.dataExpInsumo = this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.EsPorcentaje);
          break;
        case EnumCatalogoGralBanderas.ConceptosDelPpto:
          this.dataExpInsumo = this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.EsConceptosDelPpto);
          break;
        default:
          this.dataExpInsumo = this.infPpto.pptoActivoCompletoJSON.CatExpIns;
      }
    }
    if (this.filtrarTipo.length > 0) {
      switch (this.filtrarPorBandera) {
        case EnumCatalogoGralBanderas.EsCH:
          this.filtrarTipo.forEach(tipo => {
            this.dataExpInsumo = this.dataExpInsumo.concat(this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.Tipo === tipo && value.EsCostoHorario));
          });
          break;
        case EnumCatalogoGralBanderas.EsPorcentaje:
          this.filtrarTipo.forEach(tipo => {
            this.dataExpInsumo = this.dataExpInsumo.concat(this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.Tipo === tipo && value.EsPorcentaje));
          });
          break;
        case EnumCatalogoGralBanderas.ConceptosDelPpto:
          this.filtrarTipo.forEach(tipo => {
            this.dataExpInsumo = this.dataExpInsumo.concat(this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.Tipo === tipo && value.EsConceptosDelPpto));
          });
          break;
        default:
          this.filtrarTipo.forEach(tipo => {
            this.dataExpInsumo = this.dataExpInsumo.concat(this.infPpto.pptoActivoCompletoJSON.CatExpIns.filter(value => value.Tipo === tipo));
          });
      }
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridExpInsumos.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridExpInsumos.filteringLogic = FilteringLogic.Or;
    this.gridExpInsumos.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridExpInsumos, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EXP_INSUMO'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridExpInsumos.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridExpInsumos,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EXP_INSUMO'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridExpInsumos.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridExpInsumos.getRowData(rowSeleccionados[0]);
      this.gridExpInsumos.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
